import cn from 'classnames'
import { Button } from 'antd'
import { TButtonDefault as Props } from './types'
import './button.default.scss'

export const Default = ({
  children,
  className,
  secondary,
  upperCase,
  small,
  medium,
  isBody,
  inline,
  withTransparentBg,
  ...props
}: Props): JSX.Element => (
  <Button
    className={cn('button-default', 'custom-button', className, {
      secondary,
      upperCase,
      small,
      medium,
      inline,
      'like-body': isBody,
      'transparent-bg': withTransparentBg
    })}
    {...props}
  >
    {children}
  </Button>
)
